import styled from 'styled-components'

const NewsSectionStyle = styled.div`
	margin-top: var(--sectionMargin);

	.newsSectionTitle {
		margin-bottom: var(--sp13x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		.newsSectionTitle {
			margin-bottom: var(--sp10x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		.newsSectionTitle {
			margin-bottom: var(--sp8x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		.newsSectionTitle {
			margin-bottom: var(--sp7x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		.newsSectionTitle {
			margin-bottom: var(--sp7x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.newsSectionTitle {
			margin-bottom: var(--sp5x);
		}
	}
`

export default NewsSectionStyle
